import { ViewIds } from '@ardoq/api-types';

export const VIEW_SUPPORTING_DIFF = [ViewIds.BLOCK_DIAGRAM];

export const CSS_CLASS_IMAGE_DIFF_BACKGROUND = 'image-diff-background';
